export function articleImage(article) {
  if(article?.thumbnail) {
    return article.thumbnail.url;
  }
  if(article?.hero_image) {
    return article.hero_image.image?.url;
  }
  return "/card-background-placeholder.png"
}
